import React from "react";
import { Context } from "../App";
import { pad2 } from "../services/useNow";

/**
 * HUD overlay for the full-bleed background photo: a reticle, faint axes,
 * and a scale showing where we are in the photo rotation.
 */
export default function PhotoTile() {
  const { photos, currentPhotoIndex, showingHouse, phase } =
    React.useContext(Context);

  // Slide 00 is the house render, then one slide per photo.
  const total = photos.length + 1;
  const slide = showingHouse ? 0 : currentPhotoIndex + 1;
  const photo = showingHouse ? undefined : photos[currentPhotoIndex];

  // Five ticks centred on the current slide, wrapping around the rotation.
  const ticks =
    total > 1
      ? [-2, -1, 0, 1, 2].map((offset) => ({
          offset,
          index: (((slide + offset) % total) + total) % total,
        }))
      : [];

  const taken = photo?.date ? new Date(photo.date) : null;
  const takenLabel =
    taken && !isNaN(taken.getTime())
      ? taken.toLocaleDateString("en-GB", { month: "short", year: "numeric" })
      : null;

  const caption = showingHouse ? "Wyllie Home" : photo?.name || "Untitled";
  const detail = showingHouse ? phase.charAt(0).toUpperCase() + phase.slice(1) : takenLabel;

  return (
    <div className="hud">
      <div className="hud__axis hud__axis--h" />
      <div className="hud__axis hud__axis--v" />

      <div className="hud__reticle" aria-hidden>
        <i />
        <i />
        <i />
        <i />
        <span className="hud__ring" />
      </div>

      <div className="hud__ladder" aria-hidden>
        {["+2", "+1", "00", "-1", "-2"].map((l) => (
          <div key={l} className="hud__rung">
            <span>{l}</span>
          </div>
        ))}
      </div>

      <div className="hud__scale">
        {ticks.length > 0 && (
          <div className="hud__ticks">
            {ticks.map((t) => (
              <span
                key={t.offset}
                className={`hud__tick ${t.offset === 0 ? "is-current" : ""}`}
              >
                {pad2(t.index)}
              </span>
            ))}
          </div>
        )}
        <div className="hud__readout">
          <span className="hud__arrow">↑</span>
          <span className="hud__caption">
            {caption}
            {detail && <em> · {detail}</em>}
          </span>
          <span className="hud__count">
            {pad2(slide)}/{pad2(total - 1)}
          </span>
        </div>
      </div>
    </div>
  );
}
